import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { subscribeToFreePlan } from '../skills/skills_action';
import { ArrowLeftOutlined, UserOutlined, SettingOutlined } from '@ant-design/icons';
import {
  Row,
  Col,
  Card,
  Button,
  Typography,
  Radio,
  Divider,
  message,
} from 'antd';
import './billing.css';
const { Text } = Typography;


class TrialPage extends Component {
  constructor() {
    super();
    this.state = {
      frequency: 'monthly',
    };
  }

  handleFreePlan = async () => {
    try {
      const res = await this.props.subscribeToFreePlan(this.props.match.params.wId);
      if (res && res.data && res.data.success) {
        message.success('Successfully upgraded to Free plan');
        if (res.data.payment) {
          this.props.setBillingData(res.data.payment);
        }
      } else if (res && res.data && res.data.error === "limit_exceeded") {
        message.error(res.data.message);
      } else {
        message.error('Failed to upgrade to Free plan');
      }
    } catch (err) {
      console.log(err);
      message.error('Failed to upgrade to Free plan');
    }
  };

  goToBillingRedirect = (planId) => {
    const url = '/troopr_billing/' + this.props.workspace._id + '?plan_id=' + planId + '&type=subscribe';
    this.props.history.push(url);
  };

  getButtonProps = (plan) => {
    if (plan.type === 'free') {
      return { label: 'Choose →', onClick: () => this.handleFreePlan() };
    }
    if (plan.type === 'enterprise') {
      return { label: 'Talk to Us →', onClick: () => this.props.chooseUnlimitedEnterprisePlan() };
    }
    return { label: 'Checkout →', onClick: () => this.goToBillingRedirect(plan.plan_id) };
  };

  getPriceSub = (plan) => {

    return plan?.features?.static_text || '';
  };

  getFeatureHeader = (plan) => {
    if (plan.type === 'enterprise') return 'Everything in Team';
    return (plan.type === 'free') ? 'Every feature included' : 'Everything in Free';
  };

  renderLimits = (plan) => {
    const { limits, type } = plan;
    const isEnterprise = type === 'enterprise';
    const isFree = type === 'free';

    const users = isEnterprise ? 'Unlimited' : limits?.allowedActiveUsers != null ? limits.allowedActiveUsers : null;
    const configs = isEnterprise ? 'Unlimited' : limits?.allowedActiveConfig != null ? limits.allowedActiveConfig : null;

    if (users == null && configs == null) return null;

    return (
      <div style={{ marginBottom: 16 }}>
        {users != null && (
          <div style={{ display: 'flex', alignItems: 'center', marginBottom: 6 }}>
            <UserOutlined style={{ color: '#888', marginRight: 8, fontSize: 14 }} />
            <Text style={{ fontSize: 13 }}>
              {users === 'Unlimited' ? '' : 'Up to '}
              <Text strong>{`${users} people`}</Text>

            </Text>
          </div>
        )}
        {configs != null && (
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <SettingOutlined style={{ color: '#888', marginRight: 8, fontSize: 14 }} />
            <Text style={{ fontSize: 13 }}>
              {users === 'Unlimited' ? '' : 'Up to '}
              <Text strong>{`${configs} setups`}</Text>

            </Text>
          </div>
        )}
      </div>
    );
  };

  renderFeatureList = (items) => {
    if (!items || items.length === 0) return null;
    return items.map((f, i) => (
      <div key={i} style={{ display: 'flex', alignItems: 'flex-start', marginBottom: 6 }}>
        <Text style={{ fontSize: 13, color: '#444', lineHeight: '20px' }}>{f}</Text>
      </div>
    ));
  };

  renderPlanCard = (plan, highlighted) => {
    const { name, desc = [], features = {}, price } = plan;
    const { checkin = [], jira = [], common = [], support = [] } = features;
    const allFeatures = [...checkin, ...jira, ...common, ...support];
    const description = desc[0] || '';
    const displayPrice = price === '0' ? '$0' : price;
    const button = this.getButtonProps(plan);

    // Find the matching add-on for this plan (same billing_cycle via parent_plan_id)
    const addOn = this.props.pricings.find(
      (p) => p.type === 'add_on' && !p.is_archived && p.parent_plan_id === plan.plan_id
    );

    return (
      <Card
        className={`plan-card${highlighted ? ' plan-card-highlighted' : ''}`}
        hoverable
      >
        {/* Name + description */}
        <Text style={{ fontSize: 18, fontWeight: 700, color: '#111' }}>{name}</Text>
        {description && (
          <Text style={{ fontSize: 13, color: '#888', marginTop: 4, marginBottom: 12 }}>
            {description}
          </Text>
        )}

        {/* Price */}
        <div style={{ marginTop: 8, marginBottom: 2 }}>
          <Text style={{ fontSize: 42, fontWeight: 800, color: '#111', lineHeight: 1 }}>
            {displayPrice}
          </Text>
        </div>
        <Text style={{ fontSize: 13, color: '#888', marginBottom: 16 }}>
          {this.getPriceSub(plan)}
        </Text>

        {/* CTA Button */}
        <Button
          type={highlighted ? 'primary' : 'default'}
          size='large'
          block
          className={highlighted ? 'plan-accent-bg plan-accent-border' : 'plan-accent-color plan-accent-border'}
          style={{ marginBottom: 20, borderRadius: 8, fontWeight: 600 }}
          onClick={button.onClick}
        >
          {button.label}
        </Button>

        {/* Limits row */}
        {this.renderLimits(plan)}

        <Divider style={{ margin: '4px 0 16px' }} />

        {/* Features */}
        {allFeatures.length > 0 && (
          <>
            <span className='plan-feature-header'>{this.getFeatureHeader(plan)}</span>
            <div style={{ flexGrow: 1 }}>
              {this.renderFeatureList(checkin)}
              {jira.length > 0 && (
                <>
                  <Divider style={{ margin: '10px 0' }} />
                  {this.renderFeatureList(jira)}
                </>
              )}
              {common.length > 0 && (
                <>
                  {(checkin.length > 0 || jira.length > 0) && (
                    <Divider style={{ margin: '10px 0' }} />
                  )}
                  {this.renderFeatureList(common)}
                </>
              )}
              {support.length > 0 && (
                <>
                  <Divider style={{ margin: '10px 0' }} />
                  {this.renderFeatureList(support)}
                </>
              )}
            </div>
          </>
        )}

        {/* Add-on info block — only shown if this plan has a matching add-on */}
        {addOn && (
          <>
            <Divider style={{ margin: '16px 0 12px' }} />
            <div style={{
              background: '#f9f0ff',
              border: '1px solid #d3adf7',
              borderRadius: 8,
              padding: '10px 14px',
            }}>
              <Text style={{ fontSize: 12, fontWeight: 600, color: '#722ed1', display: 'block', marginBottom: 4 }}>
                Need more capacity?
              </Text>


              <Text style={{ fontSize: 12, color: '#444' }}>
                {addOn.desc ? <Text style={{ fontSize: 12, color: '#444' }}>{addOn.desc}</Text> : <>
                  <Text style={{ fontSize: 12, color: '#444' }}></Text>  +{addOn.limits && addOn.limits.allowedActiveUsers} people &amp; +{addOn.limits && addOn.limits.allowedActiveConfig} setups
                  {' '}for <Text strong>{addOn.price}</Text></>}
                {addOn.features && addOn.features.static_text && (
                  <Text type='secondary' style={{ fontSize: 11 }}> · {addOn.features.static_text}</Text>
                )}
              </Text>
            </div>
          </>
        )}
      </Card>
    );
  };

  render() {
    const { workspace } = this.props;
    const isDark = localStorage.getItem('theme') === 'dark';

    const activePlans = this.props.pricings
      .filter((plan) => !plan.is_archived && plan.type !== 'add_on')
      .map((plan) => ({
        ...plan,
        type: plan.type === 'enterprsie' ? 'enterprise' : plan.type,
      }));

    const freePlans = activePlans.filter((p) => p.type === 'free');
    const allPaidPlans = activePlans.filter((p) => p.type === 'paid');
    const enterprisePlans = activePlans.filter((p) => p.type === 'enterprise');

    // Only filter by billing_cycle if plans exist for both monthly and yearly
    const hasYearly = allPaidPlans.some((p) => p.billing_cycle === 'yearly');
    const hasMonthly = allPaidPlans.some((p) => p.billing_cycle === 'monthly');
    const showToggle = hasYearly && hasMonthly;
    const paidPlans = showToggle
      ? allPaidPlans.filter((p) => !p.billing_cycle || p.billing_cycle === this.state.frequency)
      : allPaidPlans;

    const showFree = workspace?.billing_status !== 'free';
    const displayPlans = [
      ...(showFree ? freePlans : []),
      ...paidPlans,
      ...enterprisePlans,
    ];

    const colSpan = Math.max(Math.floor(24 / Math.max(displayPlans.length, 1)), 6);
    const midPaidIdx = Math.floor(paidPlans.length / 2);

    return (
      <div
        className={`billing-wrapper${isDark ? ' dark' : ''}`}
        style={{ padding: 24 }}
      >
        {showToggle && (
          <div style={{ display: 'flex', alignItems: 'center', marginBottom: 24 }}>
            <Radio.Group
              onChange={(e) => this.setState({ frequency: e.target.value })}
              value={this.state.frequency}
              optionType='button'
              buttonStyle='solid'
            >
              <Radio.Button value={'monthly'}>Pay monthly</Radio.Button>
              <Radio.Button value={'yearly'}>Pay yearly</Radio.Button>
            </Radio.Group>
            <ArrowLeftOutlined style={{ paddingLeft: 8 }} />
            <Text mark style={{ paddingLeft: 4 }}>
              20% discount
            </Text>
          </div>
        )}

        <Row gutter={[24, 24]} align='stretch'>
          {displayPlans.map((plan) => {
            const planId = plan._id?.$oid || plan._id;
            const paidIdx = paidPlans.findIndex(
              (p) => (p._id?.$oid || p._id) === planId
            );
            const highlighted = plan.type === 'paid' && paidIdx === midPaidIdx;
            return (
              <Col span={colSpan} key={planId}>
                {this.renderPlanCard(plan, highlighted)}
              </Col>
            );
          })}
        </Row>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    workspace: state.common_reducer.workspace,
    skills: state.skills.skills,
  };
};

export default withRouter(connect(mapStateToProps, { subscribeToFreePlan })(TrialPage));
